import React from "react";
import "../../Styles/certified/ups.css";

export default function Finzly() {
  return (
    <>
      <div className="ups-certified-details-section">
        <div className="ups-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="ups-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="ups-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="ups-certified-badge"
            />
            <div className="ups-certified-company-names">
              <a href="https://about.ups.com/us/en/home.html" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/ups/ups.png"
                alt="Walkzero Logo"
                className="ups-certified-company-logo"
              />
            </a>
              <h1 className="ups-certified-full-name">
             UPS India Technology Centre
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="ups-certified-details-right">
            <img
              src="/assets/ups/ups_3.jpg"
              alt="Finzly Office"
              className="ups-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="ups-certified-description">
          <h2>
            Why UPS India Technology Centre is an Outstanding Workplaces
          </h2>
          <p>
           World’s Leader in Logistics Sector | 37th Largest Company in the world | 7th Largest Company in The United States.Operates in more than 200 countries and territories worldwide. Offers services in small package delivery, freight, logistics, customs brokerage, and e-commerce solutions. Leverages advanced technology and innovation to drive operational excellence and customer satisfaction. Committed to sustainability, diversity, inclusion, and community impact, with a strong people-first culture. 2 consecutive Great Place to Work® Certifications and 3 consecutive years of achieving an Employee Culture Survey score exceeding 90% across UPS globally.

          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="ups-certified-info-cards">
          <div className="ups-certified-info-card">
            <div className="ups-certified-info-title">COMPANY SIZE</div>
            <div className="ups-certified-info-value">2128 Employees</div>
          </div>
          <div className="ups-certified-info-card">
            <div className="ups-certified-info-title">INDUSTRY</div>
            <div className="ups-certified-info-value"> IT Sector
</div>
          </div>
          <div className="ups-certified-info-card">
            <div className="ups-certified-info-title">CONNECT</div>
            <div className="ups-certified-info-icons">
              <span className="ups-certified-icon-round">
                <a href="https://about.ups.com/us/en/home.html" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="ups-certified-icon-round">
                <a href="https://www.linkedin.com/company/ups" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="ups-certified-icon-round">
                <a href="https://www.facebook.com/ups" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="ups-certified-info-card">
            <div className="ups-certified-info-title">LOCATION (HQ)</div>
            <div className="ups-certified-info-value">Atlanta  </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="ups-certified-recognition-section">
          <h2 className="ups-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="ups-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="ups-certified-recognition-image"
            />
          </div>
          <div className="ups-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="ups-certified-life-section">
          <h2 className="ups-certified-life-title">
            Life at UPS India Technology Centre
          </h2>
          <div className="ups-certified-life-gallery">
            <div className="ups-certified-life-col">
              <img src="/assets/ups/ups_1.jpg" alt="Office 1" className="ups-certified-life-img" />
              <img src="/assets/ups/ups_2.jpg" alt="Team 1" className="ups-certified-life-img" />
            </div>
            <div className="icom-certified-life-col ups-certified-life-center">
              <img src="/assets/ups/ups_6.jpg" alt="Main Office" className="ups-certified-life-img ups-certified-life-img-large" />
            </div>
            <div className="ups-certified-life-col">
              <img src="/assets/ups/ups_5.jpg" alt="Office 2" className="ups-certified-life-img" />
              <img src="/assets/ups/ups_4.jpg" alt="Team 2" className="ups-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}